/* tslint:disable */
/* eslint-disable */
/**
 * Resell BFF Administration Integration Inditex API
 * Resell BFF Administration Integration Inditex API
 *
 * The version of the OpenAPI document: 3.1.2
 * Contact: isaacrja@ext.inditex.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AuthTokenResponse
 */
export interface AuthTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthTokenResponse
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface Blacklist
 */
export interface Blacklist {
    /**
     * Blacklist ID
     * @type {string}
     * @memberof Blacklist
     */
    'id': string;
    /**
     * Blacklist name
     * @type {string}
     * @memberof Blacklist
     */
    'name': string;
    /**
     * Username
     * @type {string}
     * @memberof Blacklist
     */
    'changeBy'?: string;
    /**
     * Creation or update date
     * @type {string}
     * @memberof Blacklist
     */
    'creationDate'?: string;
    /**
     * Creation or update date
     * @type {string}
     * @memberof Blacklist
     */
    'lastUpdate'?: string;
}
/**
 * 
 * @export
 * @interface BlacklistCreationParams
 */
export interface BlacklistCreationParams {
    /**
     * Blacklist ID
     * @type {string}
     * @memberof BlacklistCreationParams
     */
    'blacklistId': string;
    /**
     * Blacklist name
     * @type {string}
     * @memberof BlacklistCreationParams
     */
    'name': string;
}
/**
 * Returns the result of the text evaluation.
 * @export
 * @interface CheckingResult
 */
export interface CheckingResult {
    /**
     * List of tokens that match with the related text by blakclist.
     * @type {Array<TokenCheckMatch>}
     * @memberof CheckingResult
     */
    'matches'?: Array<TokenCheckMatch>;
}
/**
 * Check a set of texts with the specificated blacklists
 * @export
 * @interface CheckingSingleText
 */
export interface CheckingSingleText {
    /**
     * Blacklist IDs
     * @type {Set<string>}
     * @memberof CheckingSingleText
     */
    'blacklistIds'?: Set<string>;
    /**
     * Text to be checked
     * @type {string}
     * @memberof CheckingSingleText
     */
    'text': string;
    /**
     * Locale with modifier
     * @type {string}
     * @memberof CheckingSingleText
     */
    'locale'?: string;
    /**
     * ID of store text was requested at
     * @type {string}
     * @memberof CheckingSingleText
     */
    'storeId'?: string;
    /**
     * In addition to normal blacklist check, also check with all items of this list removed from text and blacklist tokens
     * @type {Array<string>}
     * @memberof CheckingSingleText
     */
    'deepCheckChars'?: Array<string>;
    /**
     * App code
     * @type {string}
     * @memberof CheckingSingleText
     */
    'appCode'?: string;
}
/**
 * 
 * @export
 * @interface DecryptTokenRequest
 */
export interface DecryptTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof DecryptTokenRequest
     */
    'token'?: string;
}
/**
 * Datos del error 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Código de error
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorCode'?: string;
    /**
     * Descripción del error
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorDescription'?: string;
}
/**
 * 
 * @export
 * @interface ImageServiceOutput
 */
export interface ImageServiceOutput {
    /**
     * grant type
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'tokenType'?: string;
    /**
     * client id
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'expiresIn'?: string;
    /**
     * client secret
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'extExpiresIn'?: string;
    /**
     * resource
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'expiresOn'?: string;
    /**
     * resource
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'notBefore'?: string;
    /**
     * resource
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'resource'?: string;
    /**
     * resource
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'accessToken'?: string;
}
/**
 * 
 * @export
 * @interface OperationResult
 */
export interface OperationResult {
    /**
     * Number of successfully processed entities
     * @type {number}
     * @memberof OperationResult
     */
    'successCount': number;
    /**
     * Number of entities that could not be processed
     * @type {number}
     * @memberof OperationResult
     */
    'failureCount': number;
    /**
     * Descriptions of failures
     * @type {Array<string>}
     * @memberof OperationResult
     */
    'failureMessages': Array<string>;
    /**
     * Warnings
     * @type {Array<string>}
     * @memberof OperationResult
     */
    'warningMessages': Array<string>;
}
/**
 * 
 * @export
 * @interface PageMetadata
 */
export interface PageMetadata {
    /**
     * Number of items in current page.
     * @type {number}
     * @memberof PageMetadata
     */
    'items_count': number;
    /**
     * Number of items skipped.
     * @type {number}
     * @memberof PageMetadata
     */
    'items_start': number;
    /**
     * Number of the last item in current page.
     * @type {number}
     * @memberof PageMetadata
     */
    'items_finish': number;
    /**
     * Number of items in total (all pages).
     * @type {number}
     * @memberof PageMetadata
     */
    'items_total': number;
    /**
     * Timestamp (ISO Format) when request started.
     * @type {string}
     * @memberof PageMetadata
     */
    'requestTimestamp': string;
    /**
     * Timestamp (ISO Format) when request ended.
     * @type {string}
     * @memberof PageMetadata
     */
    'responseTimestamp': string;
}
/**
 * 
 * @export
 * @interface PageOfBlacklist
 */
export interface PageOfBlacklist {
    /**
     * 
     * @type {Array<Blacklist>}
     * @memberof PageOfBlacklist
     */
    'data': Array<Blacklist>;
    /**
     * 
     * @type {PageMetadata}
     * @memberof PageOfBlacklist
     */
    'metadata': PageMetadata;
}
/**
 * 
 * @export
 * @interface PageOfToken
 */
export interface PageOfToken {
    /**
     * 
     * @type {Array<Token>}
     * @memberof PageOfToken
     */
    'data': Array<Token>;
    /**
     * 
     * @type {PageMetadata}
     * @memberof PageOfToken
     */
    'metadata': PageMetadata;
}
/**
 * 
 * @export
 * @interface ResellBackofficeUser
 */
export interface ResellBackofficeUser {
    /**
     * 
     * @type {string}
     * @memberof ResellBackofficeUser
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResellBackofficeUser
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResellBackofficeUser
     */
    'mail'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResellBackofficeUser
     */
    'roles'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResellBackofficeUser
     */
    'permissions'?: Array<string>;
    /**
     * 
     * @type {Array<UserAttributes>}
     * @memberof ResellBackofficeUser
     */
    'attributes'?: Array<UserAttributes>;
}
/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'value': string;
    /**
     * True if this token is case-sensitive.
     * @type {boolean}
     * @memberof Token
     */
    'caseSensitive'?: boolean;
    /**
     * True if this token must match full word.
     * @type {boolean}
     * @memberof Token
     */
    'whole'?: boolean;
    /**
     * True if the token generates a blocking match.
     * @type {boolean}
     * @memberof Token
     */
    'blocking'?: boolean;
    /**
     * Locales with modifier
     * @type {Set<string>}
     * @memberof Token
     */
    'locales'?: Set<string>;
}
/**
 * Token that match with the related text by blakclist.
 * @export
 * @interface TokenCheckMatch
 */
export interface TokenCheckMatch {
    /**
     * Blacklist ID
     * @type {string}
     * @memberof TokenCheckMatch
     */
    'blacklistId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenCheckMatch
     */
    'token'?: string;
    /**
     * True if the token generates a blocking match.
     * @type {boolean}
     * @memberof TokenCheckMatch
     */
    'blocking'?: boolean;
}
/**
 * 
 * @export
 * @interface TranslateInput
 */
export interface TranslateInput {
    /**
     * the output text locale.
     * @type {string}
     * @memberof TranslateInput
     */
    'targetLocale'?: string;
    /**
     * the text to translate.
     * @type {string}
     * @memberof TranslateInput
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface TranslateInputPublic
 */
export interface TranslateInputPublic {
    /**
     * the output text locale.
     * @type {string}
     * @memberof TranslateInputPublic
     */
    'targetLocale'?: string;
}
/**
 * 
 * @export
 * @interface TranslateOutput
 */
export interface TranslateOutput {
    /**
     * the text translated.
     * @type {string}
     * @memberof TranslateOutput
     */
    'translatedText'?: string;
}
/**
 * 
 * @export
 * @interface TranslateOutputPublic
 */
export interface TranslateOutputPublic {
    /**
     * the title translated.
     * @type {string}
     * @memberof TranslateOutputPublic
     */
    'title'?: string;
    /**
     * the description translated.
     * @type {string}
     * @memberof TranslateOutputPublic
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface UserAttributes
 */
export interface UserAttributes {
    /**
     * 
     * @type {string}
     * @memberof UserAttributes
     */
    'id'?: UserAttributesIdEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserAttributes
     */
    'values'?: Array<string>;
}

export const UserAttributesIdEnum = {
    Tenant: 'tenant',
    Country: 'country',
    StoreId: 'storeId'
} as const;

export type UserAttributesIdEnum = typeof UserAttributesIdEnum[keyof typeof UserAttributesIdEnum];


/**
 * ImageServiceApi - axios parameter creator
 * @export
 */
export const ImageServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Login for AI image service
         * @summary Login for AI image service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageServiceLogin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/1/resell-integration/azure/image-service-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImageServiceApi - functional programming interface
 * @export
 */
export const ImageServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImageServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * Login for AI image service
         * @summary Login for AI image service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageServiceLogin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageServiceOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageServiceLogin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ImageServiceApi - factory interface
 * @export
 */
export const ImageServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImageServiceApiFp(configuration)
    return {
        /**
         * Login for AI image service
         * @summary Login for AI image service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageServiceLogin(options?: any): AxiosPromise<ImageServiceOutput> {
            return localVarFp.getImageServiceLogin(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImageServiceApi - interface
 * @export
 * @interface ImageServiceApi
 */
export interface ImageServiceApiInterface {
    /**
     * Login for AI image service
     * @summary Login for AI image service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageServiceApiInterface
     */
    getImageServiceLogin(options?: AxiosRequestConfig): AxiosPromise<ImageServiceOutput>;

}

/**
 * ImageServiceApi - object-oriented interface
 * @export
 * @class ImageServiceApi
 * @extends {BaseAPI}
 */
export class ImageServiceApi extends BaseAPI implements ImageServiceApiInterface {
    /**
     * Login for AI image service
     * @summary Login for AI image service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageServiceApi
     */
    public getImageServiceLogin(options?: AxiosRequestConfig) {
        return ImageServiceApiFp(this.configuration).getImageServiceLogin(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IntegrationAuthApi - axios parameter creator
 * @export
 */
export const IntegrationAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
         * @summary Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resell-integration/auth/tokenWithRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get data from decrypted token
         * @summary Get data from decrypted token
         * @param {DecryptTokenRequest} [decryptTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDecryptToken: async (decryptTokenRequest?: DecryptTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resell-integration/auth/decryptToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(decryptTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationAuthApi - functional programming interface
 * @export
 */
export const IntegrationAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
         * @summary Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get data from decrypted token
         * @summary Get data from decrypted token
         * @param {DecryptTokenRequest} [decryptTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDecryptToken(decryptTokenRequest?: DecryptTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResellBackofficeUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDecryptToken(decryptTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IntegrationAuthApi - factory interface
 * @export
 */
export const IntegrationAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationAuthApiFp(configuration)
    return {
        /**
         * Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
         * @summary Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthToken(options?: any): AxiosPromise<AuthTokenResponse> {
            return localVarFp.getAuthToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Get data from decrypted token
         * @summary Get data from decrypted token
         * @param {DecryptTokenRequest} [decryptTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDecryptToken(decryptTokenRequest?: DecryptTokenRequest, options?: any): AxiosPromise<ResellBackofficeUser> {
            return localVarFp.postDecryptToken(decryptTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntegrationAuthApi - interface
 * @export
 * @interface IntegrationAuthApi
 */
export interface IntegrationAuthApiInterface {
    /**
     * Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
     * @summary Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationAuthApiInterface
     */
    getAuthToken(options?: AxiosRequestConfig): AxiosPromise<AuthTokenResponse>;

    /**
     * Get data from decrypted token
     * @summary Get data from decrypted token
     * @param {DecryptTokenRequest} [decryptTokenRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationAuthApiInterface
     */
    postDecryptToken(decryptTokenRequest?: DecryptTokenRequest, options?: AxiosRequestConfig): AxiosPromise<ResellBackofficeUser>;

}

/**
 * IntegrationAuthApi - object-oriented interface
 * @export
 * @class IntegrationAuthApi
 * @extends {BaseAPI}
 */
export class IntegrationAuthApi extends BaseAPI implements IntegrationAuthApiInterface {
    /**
     * Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
     * @summary Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationAuthApi
     */
    public getAuthToken(options?: AxiosRequestConfig) {
        return IntegrationAuthApiFp(this.configuration).getAuthToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get data from decrypted token
     * @summary Get data from decrypted token
     * @param {DecryptTokenRequest} [decryptTokenRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationAuthApi
     */
    public postDecryptToken(decryptTokenRequest?: DecryptTokenRequest, options?: AxiosRequestConfig) {
        return IntegrationAuthApiFp(this.configuration).postDecryptToken(decryptTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IntegrationL10nBlackListApi - axios parameter creator
 * @export
 */
export const IntegrationL10nBlackListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List of tokens to add
         * @summary Adds tokens to a blacklist. Tokens already present are ignored.
         * @param {string} blacklistId Blacklist ID
         * @param {Array<Token>} [token] Single text check parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistAddTokens: async (blacklistId: string, token?: Array<Token>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blacklistId' is not null or undefined
            assertParamExists('postResellIntegrationL10nBlacklistAddTokens', 'blacklistId', blacklistId)
            const localVarPath = `/resell-integration/l10n/blacklist/{blacklistId}/tokens`
                .replace(`{${"blacklistId"}}`, encodeURIComponent(String(blacklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(token, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new blacklist with the specified parameters.
         * @summary Create a new blacklist
         * @param {BlacklistCreationParams} blacklistCreationParams Blacklist paramaters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistCreate: async (blacklistCreationParams: BlacklistCreationParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blacklistCreationParams' is not null or undefined
            assertParamExists('postResellIntegrationL10nBlacklistCreate', 'blacklistCreationParams', blacklistCreationParams)
            const localVarPath = `/resell-integration/l10n/blacklists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blacklistCreationParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves existing blacklists
         * @summary Retrieve blacklists
         * @param {number} [offset] Number of items to skip.
         * @param {number} [limit] Number of items in each page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistList: async (offset?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resell-integration/l10n/blacklists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  description: Performs a blacklist check on the provided text, for all specified blacklists.         Additionally, if a storeId was specified and an external blacklist provider is configured for the store, text will also be sent for analysis.         Returns *true* if any blacklist match or analysis issue was found.
         * @summary 
         * @param {CheckingSingleText} [checkingSingleText] Single text check parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistTextsSingleCheck: async (checkingSingleText?: CheckingSingleText, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resell-integration/l10n/blacklist/texts/single-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkingSingleText, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationL10nBlackListApi - functional programming interface
 * @export
 */
export const IntegrationL10nBlackListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationL10nBlackListApiAxiosParamCreator(configuration)
    return {
        /**
         * List of tokens to add
         * @summary Adds tokens to a blacklist. Tokens already present are ignored.
         * @param {string} blacklistId Blacklist ID
         * @param {Array<Token>} [token] Single text check parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postResellIntegrationL10nBlacklistAddTokens(blacklistId: string, token?: Array<Token>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postResellIntegrationL10nBlacklistAddTokens(blacklistId, token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new blacklist with the specified parameters.
         * @summary Create a new blacklist
         * @param {BlacklistCreationParams} blacklistCreationParams Blacklist paramaters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postResellIntegrationL10nBlacklistCreate(blacklistCreationParams: BlacklistCreationParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Blacklist>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postResellIntegrationL10nBlacklistCreate(blacklistCreationParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves existing blacklists
         * @summary Retrieve blacklists
         * @param {number} [offset] Number of items to skip.
         * @param {number} [limit] Number of items in each page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postResellIntegrationL10nBlacklistList(offset?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageOfBlacklist>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postResellIntegrationL10nBlacklistList(offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  description: Performs a blacklist check on the provided text, for all specified blacklists.         Additionally, if a storeId was specified and an external blacklist provider is configured for the store, text will also be sent for analysis.         Returns *true* if any blacklist match or analysis issue was found.
         * @summary 
         * @param {CheckingSingleText} [checkingSingleText] Single text check parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText?: CheckingSingleText, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckingResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IntegrationL10nBlackListApi - factory interface
 * @export
 */
export const IntegrationL10nBlackListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationL10nBlackListApiFp(configuration)
    return {
        /**
         * List of tokens to add
         * @summary Adds tokens to a blacklist. Tokens already present are ignored.
         * @param {string} blacklistId Blacklist ID
         * @param {Array<Token>} [token] Single text check parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistAddTokens(blacklistId: string, token?: Array<Token>, options?: any): AxiosPromise<OperationResult> {
            return localVarFp.postResellIntegrationL10nBlacklistAddTokens(blacklistId, token, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new blacklist with the specified parameters.
         * @summary Create a new blacklist
         * @param {BlacklistCreationParams} blacklistCreationParams Blacklist paramaters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistCreate(blacklistCreationParams: BlacklistCreationParams, options?: any): AxiosPromise<Blacklist> {
            return localVarFp.postResellIntegrationL10nBlacklistCreate(blacklistCreationParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves existing blacklists
         * @summary Retrieve blacklists
         * @param {number} [offset] Number of items to skip.
         * @param {number} [limit] Number of items in each page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistList(offset?: number, limit?: number, options?: any): AxiosPromise<PageOfBlacklist> {
            return localVarFp.postResellIntegrationL10nBlacklistList(offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *  description: Performs a blacklist check on the provided text, for all specified blacklists.         Additionally, if a storeId was specified and an external blacklist provider is configured for the store, text will also be sent for analysis.         Returns *true* if any blacklist match or analysis issue was found.
         * @summary 
         * @param {CheckingSingleText} [checkingSingleText] Single text check parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText?: CheckingSingleText, options?: any): AxiosPromise<CheckingResult> {
            return localVarFp.postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntegrationL10nBlackListApi - interface
 * @export
 * @interface IntegrationL10nBlackListApi
 */
export interface IntegrationL10nBlackListApiInterface {
    /**
     * List of tokens to add
     * @summary Adds tokens to a blacklist. Tokens already present are ignored.
     * @param {string} blacklistId Blacklist ID
     * @param {Array<Token>} [token] Single text check parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApiInterface
     */
    postResellIntegrationL10nBlacklistAddTokens(blacklistId: string, token?: Array<Token>, options?: AxiosRequestConfig): AxiosPromise<OperationResult>;

    /**
     * Creates a new blacklist with the specified parameters.
     * @summary Create a new blacklist
     * @param {BlacklistCreationParams} blacklistCreationParams Blacklist paramaters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApiInterface
     */
    postResellIntegrationL10nBlacklistCreate(blacklistCreationParams: BlacklistCreationParams, options?: AxiosRequestConfig): AxiosPromise<Blacklist>;

    /**
     * Retrieves existing blacklists
     * @summary Retrieve blacklists
     * @param {number} [offset] Number of items to skip.
     * @param {number} [limit] Number of items in each page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApiInterface
     */
    postResellIntegrationL10nBlacklistList(offset?: number, limit?: number, options?: AxiosRequestConfig): AxiosPromise<PageOfBlacklist>;

    /**
     *  description: Performs a blacklist check on the provided text, for all specified blacklists.         Additionally, if a storeId was specified and an external blacklist provider is configured for the store, text will also be sent for analysis.         Returns *true* if any blacklist match or analysis issue was found.
     * @summary 
     * @param {CheckingSingleText} [checkingSingleText] Single text check parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApiInterface
     */
    postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText?: CheckingSingleText, options?: AxiosRequestConfig): AxiosPromise<CheckingResult>;

}

/**
 * IntegrationL10nBlackListApi - object-oriented interface
 * @export
 * @class IntegrationL10nBlackListApi
 * @extends {BaseAPI}
 */
export class IntegrationL10nBlackListApi extends BaseAPI implements IntegrationL10nBlackListApiInterface {
    /**
     * List of tokens to add
     * @summary Adds tokens to a blacklist. Tokens already present are ignored.
     * @param {string} blacklistId Blacklist ID
     * @param {Array<Token>} [token] Single text check parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApi
     */
    public postResellIntegrationL10nBlacklistAddTokens(blacklistId: string, token?: Array<Token>, options?: AxiosRequestConfig) {
        return IntegrationL10nBlackListApiFp(this.configuration).postResellIntegrationL10nBlacklistAddTokens(blacklistId, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new blacklist with the specified parameters.
     * @summary Create a new blacklist
     * @param {BlacklistCreationParams} blacklistCreationParams Blacklist paramaters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApi
     */
    public postResellIntegrationL10nBlacklistCreate(blacklistCreationParams: BlacklistCreationParams, options?: AxiosRequestConfig) {
        return IntegrationL10nBlackListApiFp(this.configuration).postResellIntegrationL10nBlacklistCreate(blacklistCreationParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves existing blacklists
     * @summary Retrieve blacklists
     * @param {number} [offset] Number of items to skip.
     * @param {number} [limit] Number of items in each page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApi
     */
    public postResellIntegrationL10nBlacklistList(offset?: number, limit?: number, options?: AxiosRequestConfig) {
        return IntegrationL10nBlackListApiFp(this.configuration).postResellIntegrationL10nBlacklistList(offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  description: Performs a blacklist check on the provided text, for all specified blacklists.         Additionally, if a storeId was specified and an external blacklist provider is configured for the store, text will also be sent for analysis.         Returns *true* if any blacklist match or analysis issue was found.
     * @summary 
     * @param {CheckingSingleText} [checkingSingleText] Single text check parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApi
     */
    public postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText?: CheckingSingleText, options?: AxiosRequestConfig) {
        return IntegrationL10nBlackListApiFp(this.configuration).postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IntegrationL10nLionatApi - axios parameter creator
 * @export
 */
export const IntegrationL10nLionatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Automatic text translation service
         * @summary Automatic text translation service
         * @param {TranslateInput} [translateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranslatePrivate: async (translateInput?: TranslateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/1/resell-integration/l10n/lionat/text/translate-private`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(translateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Automatic text translation service
         * @summary Automatic text translation service
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {TranslateInputPublic} [translateInputPublic] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranslatePublic: async (productId: number, storeId: number, lang?: string, translateInputPublic?: TranslateInputPublic, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('postTranslatePublic', 'productId', productId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('postTranslatePublic', 'storeId', storeId)
            const localVarPath = `/itxrest/1/resell-integration/l10n/lionat/text/translate-public/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(translateInputPublic, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationL10nLionatApi - functional programming interface
 * @export
 */
export const IntegrationL10nLionatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationL10nLionatApiAxiosParamCreator(configuration)
    return {
        /**
         * Automatic text translation service
         * @summary Automatic text translation service
         * @param {TranslateInput} [translateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTranslatePrivate(translateInput?: TranslateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranslateOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTranslatePrivate(translateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Automatic text translation service
         * @summary Automatic text translation service
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {TranslateInputPublic} [translateInputPublic] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTranslatePublic(productId: number, storeId: number, lang?: string, translateInputPublic?: TranslateInputPublic, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranslateOutputPublic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTranslatePublic(productId, storeId, lang, translateInputPublic, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IntegrationL10nLionatApi - factory interface
 * @export
 */
export const IntegrationL10nLionatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationL10nLionatApiFp(configuration)
    return {
        /**
         * Automatic text translation service
         * @summary Automatic text translation service
         * @param {TranslateInput} [translateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranslatePrivate(translateInput?: TranslateInput, options?: any): AxiosPromise<TranslateOutput> {
            return localVarFp.postTranslatePrivate(translateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Automatic text translation service
         * @summary Automatic text translation service
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {TranslateInputPublic} [translateInputPublic] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranslatePublic(productId: number, storeId: number, lang?: string, translateInputPublic?: TranslateInputPublic, options?: any): AxiosPromise<TranslateOutputPublic> {
            return localVarFp.postTranslatePublic(productId, storeId, lang, translateInputPublic, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntegrationL10nLionatApi - interface
 * @export
 * @interface IntegrationL10nLionatApi
 */
export interface IntegrationL10nLionatApiInterface {
    /**
     * Automatic text translation service
     * @summary Automatic text translation service
     * @param {TranslateInput} [translateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nLionatApiInterface
     */
    postTranslatePrivate(translateInput?: TranslateInput, options?: AxiosRequestConfig): AxiosPromise<TranslateOutput>;

    /**
     * Automatic text translation service
     * @summary Automatic text translation service
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {TranslateInputPublic} [translateInputPublic] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nLionatApiInterface
     */
    postTranslatePublic(productId: number, storeId: number, lang?: string, translateInputPublic?: TranslateInputPublic, options?: AxiosRequestConfig): AxiosPromise<TranslateOutputPublic>;

}

/**
 * IntegrationL10nLionatApi - object-oriented interface
 * @export
 * @class IntegrationL10nLionatApi
 * @extends {BaseAPI}
 */
export class IntegrationL10nLionatApi extends BaseAPI implements IntegrationL10nLionatApiInterface {
    /**
     * Automatic text translation service
     * @summary Automatic text translation service
     * @param {TranslateInput} [translateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nLionatApi
     */
    public postTranslatePrivate(translateInput?: TranslateInput, options?: AxiosRequestConfig) {
        return IntegrationL10nLionatApiFp(this.configuration).postTranslatePrivate(translateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Automatic text translation service
     * @summary Automatic text translation service
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {TranslateInputPublic} [translateInputPublic] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nLionatApi
     */
    public postTranslatePublic(productId: number, storeId: number, lang?: string, translateInputPublic?: TranslateInputPublic, options?: AxiosRequestConfig) {
        return IntegrationL10nLionatApiFp(this.configuration).postTranslatePublic(productId, storeId, lang, translateInputPublic, options).then((request) => request(this.axios, this.basePath));
    }
}


